<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>流程管理</p>
    </div>
    <Tabs>
      <TabPane label="全部流程" icon="logo-buffer">
        <query-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></query-list>
      </TabPane>
      <Button @click="createProcess" slot="extra" type="primary">新增流程</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="1200"
      :mask-closable="false"
      :closable="false"
    >
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新建流程</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>流程名称：</td>
              <td>
                <input
                  type="text"
                  placeholder="流程名称"
                  v-model="item.name"
                  style="width:400px;"
                />
              </td>
            </tr>
          </table>
          <div>
            <div>
              <p>当前流程
                <Button @click="sortDisplay">排序预览</Button>
              </p>
            </div>
            <div class="p-wrapper">
              <div v-for="(p,i) in item.flow" :key="i" class="p-item">
                <p>{{p.name}}</p>
                <p><input type="number" v-model="p.index" style="width:40px;text-align:center;"/></p>
                <span class="d-icon">
                  <Icon type="ios-trash-outline" @click="del(p,i)" />
                </span>
                </div>
            </div>
            
          </div>
          <div>
            <div>
              <p>已删除流程</p>
            </div>
            <div class="p-wrapper">
              <div v-for="(p,i) in item.deletedProcessList" :key="i" class="p-item">
                <p>{{p.name}}</p>
                <p><Button @click="restore(p,i)">复原</Button></p>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')"  >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import queryList from "@/components/Common/QueryList.vue";
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";


function itemFac(){
  return {
    name:"",
    flow:[],
    deletedProcessList:[]
  };
}

export default {
  name: "workflowManage",
  props: [],
  components: {
    queryList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "workflowList",
      update_count: 0,
      modalValue:{
          newCreate:false,
      },
      item:itemFac(),
      processList:[],
      columnsFormatData: [
        {
          title: "名称",
          key: "name",
          align: "center"
        },
        {
          title: "流程",
          key: "flow",
          align: "center"
        },
        {
          title: "创建时间",
          key: "record_time",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red",marginRight:'5px' },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              ),
              
            ]);
          }
        }
        
      ]
    };
  },
  computed:{

  },
  created(){
    this.getOptionsData();
  },
  methods: {
    getOptionsData(){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'processOption',
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.processList = response.data.res_record;
            for(let i of this.processList){
              i.index = i.id;
            }
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    sortDisplay(){
      this.item.flow.sort(
        (a,b)=>{
          return a.index-b.index;
        }
      );
    },
    createProcess(){
      this.item = itemFac();
      this.item.flow = JSON.parse(JSON.stringify(this.processList));
      this.openModal('newCreate');
    },
    del(p,i){
      this.item.deletedProcessList.push(p);
      this.item.flow.splice(i,1);
    },
    restore(p,i){
      this.item.flow.push(p);
      this.item.deletedProcessList.splice(i,1);
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "流程：" +
          value.name +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delWorkflow",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    newCreateSubmit(value){
      let form = new FormData();
        form.append("userToken", userToken);
        form.append("flow", this.label);
        form.append("name", this.name);
        form.append("askData", "createWorkflow");
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/process", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              this.$Message.success("新建成功！");
              this.update_count++;
              this.closeModal(value);
            } else {
              this.$Message.error(response.data.info);
            }
          })
          .catch(error => {
            this.$Message.error(error + "未知错误！");
          });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}

.p-wrapper{
  border:1px solid #333;
  min-height: 100px;
  display: flex;
  padding: 10px;
}

.p-item{
  width:100px;
  position: relative;
  padding: 10px;
  border:1px solid #999;
}

.d-icon{
  position: absolute;
  right:3px;
  top:2px;
  cursor: pointer;
}
</style>